<template>
  <div>
    <QS-h3-title v-if="tabType" class="purchase" title="逾期单详情">
      <el-button slot="right" @click="goBack">返回</el-button>
    </QS-h3-title>
    <QS-h4-title title="逾期单信息">
      <QSColumnBox
        slot="body"
        :source="infoData"
        :list="baseInfoColumns"
        :separator="columnSeparator"
        label-width="170"
      >
      </QSColumnBox>
    </QS-h4-title>

    <QS-h4-title title="跟进记录">
      <QS-common-table
        :data="infoData.followInfoVOList"
        :columns="followColumns"
        :pagination="false"
      >
      </QS-common-table>
    </QS-h4-title>
  </div>
</template>

<script>

import config from '../../config/detailList/overdueDetail'
// eslint-disable-next-line import/no-cycle
import { overdueDetail, withdrawApproval } from '@/api/domain/orders'

export default {
  components: {
  },
  data() {
    const {
      followColumns,
      baseInfoColumns,
    } = config.call(this)
    return {
      tabType: '', // 客户&车辆详情/个人租赁跳转到个人租赁详情的类型
      // 逾期单信息数据
      infoData: {
        followInfoVOList: [], // 跟进记录
        batchAccruedRecordVOList: [], // 逾期收款记录
      },
      followColumns,
      baseInfoColumns,
      // 逾期单信息map
      columnSeparator: ': ',
    }
  },
  created() {
    const { tabType = '' } = this.$route.query
    this.tabType = tabType
    this.overdueDetail()
  },
  methods: {
  // 返回上一级
    goBack() {
      this.$router.go(-1)
    },
    async overdueDetail() {
      const { overdueId } = this.$route.query
      const { code, data } = await overdueDetail({
        overdueId,
      })
      if (code === 1) {
        this.infoData = data
      }
    },
    // 详情
    // eslint-disable-next-line vue/no-unused-properties
    detailHandle({ id }) {
      this.$router.push({
        path: '/purchase/batchCollectionRecord/batchCollectionRecordDetails',
        query: { type: 'overdue', id },
      })
    },
    // 撤回
    // eslint-disable-next-line vue/no-unused-properties
    backoutHandle(row) {
      this.$confirm('确认撤回吗？撤回后会将收款变为作废状态，需要重新发起收款', '是否撤回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'waring',
      }).then(() => {
        this.withdrawApproval(row)
      }).catch(() => null)
    },
    // 撤回审批
    async withdrawApproval(row) {
      const params = {
        bizId: row.id,
        bizType: 1,
      }
      const { code } = await withdrawApproval(params)
      try {
        if (code === 1) {
          this.$message({
            type: 'success',
            message: '撤回成功',
            onClose: () => {
              this.overdueDetail()
            },
          })
        }
      } catch (error) {
        console.log(error, 'withdrawApproval')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
</style>

